const messages = {
    accountBox: {
        title: "Irányítópult",
        description: "Kövesse gyorsan promócióit és pontjait.",
        button: "IRÁNYÍTÓPULT MEGNYITÁSA",
    },
};

export default {
    messages,
};
